import { Injectable } from '@angular/core';
import { IMiAppSetting } from 'src/app/models/imi-app-setting';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  static ApiRoot:string;
  static APPMainsettings:IMiAppSetting;
  constructor() { }
}
